if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.maxPage = null;
      this.MIN_PRODUCTS = 4; // minimum products to collect before appending
      this.MAX_LOOKAHEAD = 10; // max pages to scan in one load-more click
    }

    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }

      // On initial page load, if filters are active and fewer than MIN_PRODUCTS
      // are visible, auto-fetch more pages until we hit the threshold
      if (window.location.search.includes('filter.')) {
        const visibleProducts = this.grid ? this.grid.querySelectorAll('.column').length : 0;
        if (visibleProducts < this.MIN_PRODUCTS) {
          console.log(`[Pagination] Initial load has ${visibleProducts} products (under ${this.MIN_PRODUCTS} threshold), auto-fetching more...`);
          this.collectProducts();
        }
      }
    }

    addUrlParam(search, key, val) {
      const newParam = key + '=' + val;
      let params = '?' + newParam;
      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) params += '&' + newParam;
      }
      return params;
    }

    loadMore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.collectProducts();
        this.blur();
        return false;
      });
    }

    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.collectProducts();
        }
      }, { threshold: [0, 1] });
      base.observer.observe(base);
    }

    // Fetches pages until we have MIN_PRODUCTS collected or run out of pages
    async collectProducts() {
      if (this.getAttribute('loading')) return;
      this.setAttribute('loading', true);
      if (this.button) this.button.classList.add('loading');

      let collectedItems = [];
      let pagesScanned = 0;
      let reachedEnd = false;

      while (collectedItems.length < this.MIN_PRODUCTS && pagesScanned < this.MAX_LOOKAHEAD) {
        // Stop if we know we're past the last page
        if (this.maxPage && this.i > this.maxPage) {
          reachedEnd = true;
          break;
        }

        const url = document.location.pathname + this.addUrlParam(document.location.search, 'page', this.i);
        console.log(`[Pagination] Fetching page ${this.i} — ${url}`);

        let html;
        try {
          const response = await fetch(url);
          html = await response.text();
        } catch (e) {
          console.warn('[Pagination] Fetch failed:', e);
          break;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Detect max page from pagination links
        if (!this.maxPage) {
          doc.querySelectorAll('.page-numbers a').forEach(link => {
            const match = link.href.match(/[?&]page=(\d+)/);
            if (match) {
              const n = parseInt(match[1]);
              if (n > (this.maxPage || 0)) this.maxPage = n;
            }
          });
        }

        const grid = doc.getElementById('product-grid');

        // No grid in response = no more pages
        if (!grid) {
          reachedEnd = true;
          break;
        }

        const products = Array.from(grid.querySelectorAll('.column'));
        console.log(`[Pagination] Page ${this.i} — ${products.length} visible products found`);

        collectedItems = collectedItems.concat(products);
        pagesScanned++;
        this.i++;

        // Check if this page had a next page
        if (!doc.querySelector('pagination-theme')) {
          reachedEnd = true;
          break;
        }
      }

      if (collectedItems.length > 0) {
        collectedItems.forEach(item => this.grid.appendChild(item));
        console.log(`[Pagination] Appended ${collectedItems.length} products from ${pagesScanned} page(s)`);

        dispatchCustomEvent('pagination:page-changed', { url: document.location.href });

        if (this.animations_enabled) {
          gsap.set(collectedItems, { opacity: 0, y: 30 });
          gsap.to(collectedItems, {
            duration: 0.5,
            y: 0,
            opacity: 1,
            stagger: 0.05,
            onComplete: () => {
              this.removeAttribute('loading');
              if (this.button) this.button.classList.remove('loading');
            }
          });
        } else {
          this.removeAttribute('loading');
          if (this.button) this.button.classList.remove('loading');
        }
      } else {
        // Nothing found across all scanned pages
        console.log(`[Pagination] No products found across ${pagesScanned} pages`);
        this.removeAttribute('loading');
        if (this.button) this.button.classList.remove('loading');
      }

      if (reachedEnd) {
        this.hidePagination();
      }
    }

    hidePagination() {
      if (this.observer) this.observer.unobserve(this);
      if (this.button) this.button.classList.add('visually-hidden');
    }
  }

  customElements.define('pagination-theme', Pagination);
}
